import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useForm } from "react-hook-form";
import deleteIco from "../../../lib/img/deleteIco.png";
import "./addFile.css";
import { addOneFile } from "../../../services/RequestsToServer";


function AddFileModal({ show, close, addFile }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [fileType, setFileType] = useState('instruction');
  const [error, setError] = useState(null);

  const {
  register,
  handleSubmit,
  reset,
  formState: { errors }
  } = useForm();

  const handleClose = () => {
    reset();
    setSelectedFile(null);
    setError(null);
    close();
  };

  const deleteSelectedFile = () => {
    setSelectedFile(null);
    const fileInput = document.getElementById("loadInput");
    if (fileInput) {
    fileInput.value = ""; // очищуємо інпут вручну
  }
  };

  const handleFileChange = (event) => {
    console.log("selected File", event.target.files[0]);
    setSelectedFile(event.target.files[0]);
  };

    const openLoading = (event) => {
    const loadInp = document.getElementById("loadInput");
    if (loadInp) {
    loadInp.click();
  }
};

  const onSubmit = async (data) => {
    console.log("FOrm request ", data);
  if (!selectedFile) {
    setError("Оберіть pdf файл!");
    return;
  } else {
    setError(null);
  }

  const formData = new FormData();
  formData.append("file", selectedFile);
  formData.append("name", data.name);
  formData.append("type", data.type);

  try {
    const response = await addOneFile(formData);
    if(response.status === 200) {
      const newFile = await response.json();
      addFile(newFile);
      reset();
      setSelectedFile(null);
      setError(null);
      close();
    } else {
      setError(String(response));
    }
  } catch (err) {
    setError("Не вдалося завантажити файл: " + err.message);
  }
};


  return (
    <Modal show={show} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title>Додати файл</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3" controlId="fileName">
            <Form.Label>Назва файлу</Form.Label>
            <Form.Control
              type="text"
              // value={fileName}
              // onChange={(e) => setFileName(e.target.value)}
              placeholder="Введіть назву"
              {...register("name", { required: "Назва обов’язкова" })}
              isInvalid={errors.name}
            />
            <Form.Control.Feedback type="invalid">
              {errors.name?.message}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="selectType">
            <Form.Label>Оберіть тип</Form.Label>
            <Form.Control
              as="select"
              {...register("type")}
              // value={fileType}
              // onChange={(e) => setFileType(e.target.value)}
            >
              <option value="instruction">Інструкція</option>
              <option value="manual">Посібник</option>
            </Form.Control>
          </Form.Group>
          <Form.Group className="mb-3" controlId="fileLoadInp">
            <Form.Label>Завантажити файл</Form.Label>
            <Form.Control 
              readOnly
              className='loadFileStyle'
              defaultValue={"Натисніть, щоб обрати файл"}
              type="text" 
              onClick={openLoading}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Control 
              hidden
              id='loadInput'
              type="file" 
              accept=".pdf" 
              onChange={handleFileChange} 
            />
            <Form.Control.Feedback type="invalid">
              {errors.file?.message}
            </Form.Control.Feedback>

            {selectedFile && (
              <ul className="ulStyleFile mt-2 mb-0">
                <li>{selectedFile.name} <img src={deleteIco} onClick={deleteSelectedFile} className='deleteIcoModalAdd'/></li>
              </ul>
            )}
          </Form.Group>

        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button className='closeBtnAdd' variant="secondary" onClick={handleClose}>
          Закрити
        </Button>
        <Button className='btnStyleAdd' variant="secondary" onClick={handleSubmit(onSubmit)}>
          Додати
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddFileModal;